module.exports = {"id":"152747","name":"Aaron Lennon","rating":"77","photo":"./data/images/photos/2/152747.png","club":{"name":"Burnley","logo":"./data/images/clubs/Burnley.png"},"positions":["MD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AaronLennon0.json
// module id = 45
// module chunks = 0